import { Directive, Inject, Injector, OnInit } from '@angular/core';
import { UserSettings, UserSettingsToken } from '@farris/devkit';
import { FarrisDatepickerComponent } from '@farris/ui-datepicker';
@Directive({
  selector: '[farris-date-localization]'
})
export class FarrisDateLocalizationDirective implements OnInit {
  constructor(private injector: Injector, @Inject(UserSettingsToken) private userSettings: UserSettings, private componentRef: FarrisDatepickerComponent) {

  }
  ngOnInit(): void {
    this.localize();
  }
  private localize() {
    if (this.userSettings && this.componentRef) {
      const { dateFormat = null, timeFormat = null } = this.userSettings;
      if (dateFormat === null && timeFormat === null) {
        return;
      }
      if (timeFormat && timeFormat && this.componentRef.showTime === true) {
        this.componentRef.dateFormat = `${dateFormat} ${timeFormat}`;
        this.componentRef.dateOpts.dateFormat = `${dateFormat} ${timeFormat}`;
        this.componentRef.updateValue(this.componentRef.value);
      } else if (dateFormat) {
        this.componentRef.dateFormat = `${dateFormat}`;
        this.componentRef.dateOpts.dateFormat = `${dateFormat}`;
        this.componentRef.updateValue(this.componentRef.value);
      }
    }
  }
}
